export { default as GrayLogo } from './GrayLogo'
export { default as Logo } from './Logo'
export { default as NavyLogo } from './NavyLogo'
export { default as WhiteLogo } from './WhiteLogo'



// WEBPACK FOOTER //
// ./src/core/icons/Logo/index.js